"use client";

import { useState, useEffect, useCallback } from 'react';

// Global state to allow sharing test chat toggle without prop drilling
let globalShowTestChat = false;
const listeners = new Set<(show: boolean) => void>();

export function useTestChat() {
  const [showTestChat, setShowTestChatState] = useState(globalShowTestChat);

  useEffect(() => {
    // Sync with global state on mount
    setShowTestChatState(globalShowTestChat);
    
    // Subscribe to changes
    listeners.add(setShowTestChatState);
    return () => {
      listeners.delete(setShowTestChatState);
    };
  }, []);

  const setShowTestChat = useCallback((valOrUpdater: boolean | ((prev: boolean) => boolean)) => {
    const nextVal = typeof valOrUpdater === 'function' ? valOrUpdater(globalShowTestChat) : valOrUpdater;
    
    // Only update if changed
    if (globalShowTestChat !== nextVal) {
      globalShowTestChat = nextVal;
      listeners.forEach((listener) => listener(nextVal));
    }
  }, []);

  return { showTestChat, setShowTestChat };
}
